import Switch from '@mui/material/Switch';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import {
  SubscriptionCategory,
  SubscriptionConfigSettings,
  SubscriptionConfigType,
  SubscriptionConfigView,
  SubscriptionEvent,
  SubscriptionType,
  useUserInfo,
} from '@ozark/common';

interface Props {
  category: SubscriptionConfigSettings;
  type: SubscriptionConfigType;
  defaultIsSubscribed: boolean;
  subscriptionConfig: SubscriptionConfigView | undefined;
  toggleSubscription: (
    categoryKey: SubscriptionCategory,
    typeKey: SubscriptionType,
    eventKey: SubscriptionEvent,
    isSubscribed: boolean
  ) => Promise<void>;
}

export const SwitchTableRow = ({
  category,
  type,
  defaultIsSubscribed,
  subscriptionConfig,
  toggleSubscription,
}: Props) => {
  const {role, groupRole} = useUserInfo();
  const claims = {role, groupRole};
  return (
    <TableRow>
      <TableCell sx={{pl: '40px'}}>{type.title}</TableCell>

      {Object.values(SubscriptionEvent).map(eventKey => {
        if (!type.events[eventKey].isVisible(claims)) {
          return <TableCell key={`${category.key}-${type.key}-${eventKey}`}></TableCell>;
        }

        return (
          <TableCell key={`${category.key}-${type.key}-${eventKey}`}>
            <Switch
              checked={
                (subscriptionConfig?.[category.key]?.[type.key]?.[eventKey] as
                  | boolean
                  | undefined) ?? defaultIsSubscribed
              }
              onChange={(_event, checked) =>
                toggleSubscription(category.key, type.key, eventKey, checked)
              }
            />
          </TableCell>
        );
      })}
    </TableRow>
  );
};
